import React, { useContext } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import ImageViewContext from "context/ImageViewContext";

export default function ImageViewer() {
  const {imageViewerData, setImageViewerData} = useContext(ImageViewContext);
  const [isOpened, setOpened] = React.useState(imageViewerData.isOpened)

  /**
   * function update isOpened if imageViewerData.isOpened changes
   */
  React.useEffect(() => {
    setOpened(imageViewerData.isOpened);
    window.scrollTo(0,0);
  }, [imageViewerData.isOpened])

  const [images, setImages] = React.useState([])
  const [
    photoIndex,
    setPhotoIndex
  ] = React.useState(imageViewerData.index || 0);
  const [nextSrc, setNextSrc] = React.useState(getInitNextSrc());
  const [prevSrc, setPrevSrc] = React.useState(getInitPrevSrc());

  /**
   * function return next image src
   */
  function getInitNextSrc(): string | undefined {
    if (images.length > 1) {
      return images[(photoIndex + 1) % images.length]
    }
  }

  /**
   * function return previous image src
   */
  function getInitPrevSrc(): string | undefined {
    if (images.length > 1) {
      return images[(photoIndex + images.length - 1) % images.length]
    }
  }

  /**
   * update images and photoIndex if imageViewerData.images changes
   */
  React.useEffect(() => {
    function getImages() {
      if (Array.isArray(imageViewerData.images)) {
        return imageViewerData.images
      } else if (typeof imageViewerData.images === 'string') {
        return [imageViewerData.images]
      }
      return []
    }

    setImages(getImages());
    setPhotoIndex(imageViewerData.index);
  }, [imageViewerData.images])

  /**
   * close image viewer
   */
  function close() {
    setImageViewerData({
      images: [],
      isOpen: false,
    })
  }

  /**
   * update nextSrc and prevSrc if photoIndex changes
   */
  React.useEffect(() => {
    setNextSrc(getInitNextSrc())
    setPrevSrc(getInitPrevSrc())
  }, [photoIndex])

  /**
   * window scroll handler
   */
  const handleScroll = React.useCallback(() => {
    window.scrollTo(0,0);
  }, [setOpened])

  /**
   * add or remove window event listener
   */
  React.useEffect(() => {
    if (isOpened) {
      window.addEventListener('scroll', handleScroll);
    } else {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [isOpened, handleScroll])


  return isOpened && (
    <Lightbox
      mainSrc={images[photoIndex]}
      nextSrc={nextSrc}
      prevSrc={prevSrc}
      onCloseRequest={close}
      onMovePrevRequest={() =>
        setPhotoIndex((prev: number) => {
          return (prev + images.length - 1) % images.length
        })
      }
      onMoveNextRequest={() =>
        setPhotoIndex((prev: number) => {
          return (prev + images.length + 1) % images.length
        })
      }
    />
  ) || null
}
